<lib-card-list
  data-cy="monitoring-list"
  (cardAction)="onCardAction($event)"
  (emptyStateAction)="createNewWorkflow()"
  (itemClick)="onWorkflowClick($event)"
  (pageChange)="onPageChange($event)"
  (searchChange)="onSearchChange($event)"
  (statusFilterChange)="onStatusFilterChange($event)"
  (clearFilters)="clearServerFilters()"
  [breadcrumbs]="breadcrumbs"
  [cardConfig]="cardConfig"
  [dataSource$]="dataSource$"
  [dataSourceConfig]="dataSourceConfig"
  [emptyStateActionIcon]="'pi pi-plus'"
  [emptyStateActionLabel]="'Crear Workflow'"
  [emptyStateDescription]="
    'No se han encontrado workflows en el sistema. Crea un nuevo workflow para comenzar.'
  "
  [emptyStateSubtext]="'Los workflows aparecerán aquí una vez que sean creados'"
  [emptyStateTitle]="'No hay workflows disponibles'"
  [isLoading]="isLoading"
  [key]="currentPageKey()"
  [hasActiveFilters]="hasActiveFilters()"
  [searchTerm]="currentSearch()"
  [showClearFiltersButton]="true"
  [showEmptyStateAction]="true"
  [showStatusFilter]="true"
  [statusFilterValue]="currentStatusFilter()"
></lib-card-list>
